import { SurveyComponent, Survey } from "@tree-company/tree-query";
import { useContext, useMemo } from "react";
import { Navigate, useParams } from "react-router";
import { surveySettingsForStatement } from "../survey";
import { STATEMENT_KEYS } from "../data/statements";
import { LocaleContext } from "../app";

/**
 * We create a small wrapper component so that we are sure that the statement exists when we render `StatementSurvey`
 */
export function StatementSurveyWrapper({ apiClient }) {
  const { statement } = useParams();

  // Redirect back to start page if the user went to a url that doesn't exist
  if (!STATEMENT_KEYS.includes(statement)) {
    return <Navigate to={"../"} />;
  }

  return (
    <StatementSurvey
      apiClient={apiClient}
      statement={statement}
      key={statement}
    />
  );
}

export function StatementSurvey({ apiClient, statement }) {
  const { locale } = useContext(LocaleContext);
  const treesponse = useMemo(() => {
    return apiClient.initTreesponse({
      language: locale,
      surveyVersion: "v1",
      initialAnswers: { statement },
    });
  }, [statement]);

  const survey = useMemo(() => {
    const survey = new Survey(
      surveySettingsForStatement(statement),
      treesponse,
    );
    // If we are on the "like" page and there are only two comments, redirect to next page.
    survey.settings.pages
      .find((page) => page.key === "like")
      .sections.find((section) => section.key === "like").onOptionsLoaded = (
      options,
    ) => {
      if (options.length < 2) {
        survey.nextPage();
      }
    };

    return survey;
  }, [statement]);

  return <SurveyComponent survey={survey} />;
}
